module.exports = __webpack_public_path__ + "static/img/031.995e7e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/031.png
// module id = w8+T
// module chunks = 1